import { createContext, useContext, useEffect, useState } from "react";
import { getPreferences } from "../layouts/settings/api"; // adjust
import { useAuth } from "layouts/authentication/AuthContext"; 
const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
    const { tenantId } = useAuth();
  const [currency, setCurrency] = useState({ symbol: "₹", code: "INR" }); // default

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        const res = await getPreferences(tenantId);
        // console.log("Currency response", res);
        
        setCurrency({
          symbol: res.data.currency_symbol,
          code: res.data.currency_code,
        });
      } catch (err) {
        console.error("Currency load failed", err);
      }
    };

    if (tenantId) loadCurrency();
  }, [tenantId]);

  return (
    <CurrencyContext.Provider value={currency}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);